import { CalendarDays } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "../../../../../components/tailwind/card";
import { workflowTheme } from "../../../utils/workflowBuilderTheme";

export function WorkflowAnalyticsDailyBreakdown({ dailyRows }) {
  if (!dailyRows.length) return null;

  return (
    <Card className={`h-full shadow-sm ${workflowTheme.card}`}>
      <CardHeader className="p-4 md:p-5 pb-2 space-y-1">
        <CardTitle className={`flex items-center gap-2 text-sm ${workflowTheme.textPrimary}`}>
          <CalendarDays className={`h-4 w-4 shrink-0 ${workflowTheme.textSecondary}`} />
          Daily breakdown
        </CardTitle>
        <p className={`text-xs font-normal ${workflowTheme.textSecondary}`}>
          Session outcomes by day this month
        </p>
      </CardHeader>
      <CardContent className="p-4 md:p-5 pt-2">
        <div className="overflow-x-auto -mx-1 px-1">
          <table className="w-full min-w-[480px] text-sm">
            <thead>
              <tr className={`text-left text-[11px] uppercase tracking-wide ${workflowTheme.textMuted}`}>
                <th className="pb-2.5 font-semibold">Date</th>
                <th className="pb-2.5 font-semibold text-right">Started</th>
                <th className="pb-2.5 font-semibold text-right">Completed</th>
                <th className="pb-2.5 font-semibold text-right">Abandoned</th>
                <th className="pb-2.5 font-semibold text-right">Handoff</th>
                <th className="pb-2.5 font-semibold text-right">Avg time</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100 dark:divide-slate-800">
              {dailyRows.map((row) => (
                <tr key={row.date}>
                  <td className={`py-2.5 font-medium ${workflowTheme.textPrimary}`}>
                    {row.dayLabel}
                  </td>
                  <td className={`py-2.5 text-right tabular-nums ${workflowTheme.textPrimary}`}>
                    {row.started}
                  </td>
                  <td className="py-2.5 text-right tabular-nums text-green-600 dark:text-green-400">
                    {row.completed}
                    {row.started > 0 && (
                      <span className={`ml-1 text-[11px] ${workflowTheme.textMuted}`}>
                        ({row.completionRate}%)
                      </span>
                    )}
                  </td>
                  <td className="py-2.5 text-right tabular-nums text-red-600 dark:text-red-400">
                    {row.abandoned}
                  </td>
                  <td className={`py-2.5 text-right tabular-nums ${workflowTheme.textPrimary}`}>
                    {row.handoff}
                  </td>
                  <td className={`py-2.5 text-right ${workflowTheme.textSecondary}`}>
                    {row.avgDurationLabel}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
}
